import { useEffect, useState, useCallback } from "react";
import { useStytchMemberSession, useStytchB2BClient } from "@stytch/react/b2b";
import { useNavigate } from "react-router-dom";
import { Spinner } from "@/components/ui/spinner";
import useQueryStringParams from "../../hooks/useQueryStringParams";

const Authenticate: React.FC = (): JSX.Element => {
  const stytch = useStytchB2BClient();
  const { session } = useStytchMemberSession();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  const { slug, token } = useQueryStringParams(["slug", "token"]);

  const redirectToLogin = useCallback(
    (slug: string | null) => {
      const loginPath = slug ? `/auth/login` : "/";
      navigate(loginPath);
    },
    [navigate]
  );

  useEffect(() => {
    const authenticateUser = async () => {
      if (session) {
        navigate(`/funnel`);
        return;
      }

      if (token) {
        try {
          await stytch.magicLinks.authenticate({
            magic_links_token: token,
            session_duration_minutes: 20160,
          });
          navigate(`/funnel`);
        } catch (error) {
          console.error("Authentication error:", error);
          setError("Failed to authenticate. Please try again.");
          redirectToLogin(slug);
        }
      } else {
        redirectToLogin(slug);
      }
    };

    authenticateUser();
  }, [stytch, session, navigate, slug, token, redirectToLogin]);

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 py-8">
        <p className="text-red-500">{error}</p>
        <Spinner />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center py-8">
      <Spinner />
    </div>
  );
};

export default Authenticate;
